import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FaUpload } from "react-icons/fa";
import { TiDelete } from "react-icons/ti";
import "./CustomAgents.css";

export default function CustomModalAgents({
  toggleModal,
  addTeamLead,
  currentTeamLead,
}) {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    Email: "",
    Role: "agent",
    Password: "",
    profilePic: null,
    profilePicUrl: "",
  });

  // Update formData when currentTeamLead changes
  useEffect(() => {
    if (currentTeamLead) {
      setFormData({
        ...currentTeamLead,
        profilePic: null, // Keep as null for simplicity
        profilePicUrl: currentTeamLead.profilePicUrl || "",
      });
    }
  }, [currentTeamLead]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevState) => ({
        ...prevState,
        profilePic: file,
        profilePicUrl: URL.createObjectURL(file),
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentTeamLead) {
      // Handle editing existing team lead
      Object.assign(currentTeamLead, formData);
    } else {
      // Add new team lead
      addTeamLead(formData);
    }
    toggleModal();
  };

  const removeImage = () => {
    setFormData((prevState) => ({
      ...prevState,
      profilePic: null,
      profilePicUrl: "",
    }));
  };

  return (
    <div className="modal_overlay">
      <div className="modal_container">
        <div className="flex justify-end">
          <button className="modal_close_button" onClick={toggleModal}>
            <TiDelete size={24} className="text-red-400 hover:text-red-600" />
          </button>
        </div>

        <h2 className="modal_title">
          {currentTeamLead ? "Edit Agent" : "Add Agent"}
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Input Fields */}
          <div className="modal_field">
            <label htmlFor="first_name">First Name</label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
              placeholder="Enter First Name"
              required
            />
          </div>
          <div className="modal_field">
            <label htmlFor="last_name">Last Name</label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
              placeholder="Enter Last Name"
              required
            />
          </div>
          <div className="modal_field">
            <label htmlFor="Email">Email</label>
            <input
              type="email"
              id="Email"
              name="Email"
              value={formData.Email}
              onChange={handleInputChange}
              placeholder="Enter Agent Email"
              required
            />
          </div>

          <div className="modal_field">
            <label htmlFor="Password">Password</label>
            <input
              type="password"
              id="Password"
              name="Password"
              value={formData.Password}
              onChange={handleInputChange}
              placeholder="Enter Password"
              required
            />
          </div>
          {/* <div className="modal_field">
            <label htmlFor="type">Type</label>
            <input
              type="text"
              id="type"
              name="type"
              value={formData.type}
              readOnly
              placeholder="Type"
            />
          </div> */}

          {/* Drag and Drop Upload Section */}
          {/* <div
            className={`flex flex-col items-center justify-center border border-gray-400 rounded-md mt-6 p-6 sm:p-10 w-full max-w-[90%] sm:max-w-[350px] mx-auto ${
              formData.profilePic
                ? "opacity-50 cursor-not-allowed"
                : "hover:cursor-pointer"
            }`}
            onClick={() => {
              if (!formData.profilePic) {
                document.getElementById("profilePic").click();
              }
            }}
          >
            <input
              type="file"
              id="profilePic"
              name="profilePic"
              className="hidden"
              onChange={handleFileChange}
              accept="image/*"
            />
            <FaUpload size={28} className="text-gray-600 mb-2" />
            <span className="text-gray-600 text-sm sm:text-lg text-center">
              {formData.profilePic
                ? "Image Uploaded"
                : "Click and Drop to Upload"}
            </span>
          </div> */}

          {/* Display Selected Image */}
          {/* {formData.profilePicUrl && (
            <div className="flex flex-wrap gap-4 justify-center px-2 sm:px-6 mt-4">
              <div className="relative w-[30%] sm:w-[32%] mb-4">
                <img
                  src={formData.profilePicUrl}
                  alt="Selected Profile"
                  className="object-cover rounded-md w-full h-auto"
                />
                <button
                  className="absolute top-[-10px] right-[-10px] bg-white rounded-full p-1 shadow-md"
                  onClick={removeImage}
                >
                  <TiDelete size={20} className="text-red-500" />
                </button>
              </div>
            </div>
          )} */}

          <div className="modal_actions">
            <button
              type="button"
              className="button_cancel"
              onClick={toggleModal}
            >
              Cancel
            </button>
            <button type="submit" className="button_submit">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

CustomModalAgents.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  addTeamLead: PropTypes.func.isRequired,
  currentTeamLead: PropTypes.object,
};
